import { Helmet } from 'react-helmet-async'
import { buildAbsoluteUrl } from '../lib/site'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  ogImage?: string
  canonical?: string
  lang?: string
  noindex?: boolean
}

const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  canonical,
  lang = 'ru',
  noindex = false,
}: SEOProps) => {
  const siteName = 'InfotechPro'
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`
  const normalizedLang = lang.startsWith('en') ? 'en' : 'ru'
  const pageUrl = canonical || (typeof window !== 'undefined' ? window.location.href : buildAbsoluteUrl('/'))
  const imageUrl = ogImage ? buildAbsoluteUrl(ogImage) : buildAbsoluteUrl('/favicon.png')
  const robots = noindex ? 'noindex, nofollow' : 'index, follow'

  return (
    <Helmet htmlAttributes={{ lang: normalizedLang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={pageUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content={normalizedLang === 'ru' ? 'ru_RU' : 'en_US'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      <meta name="robots" content={robots} />
      <meta name="author" content="InfotechPro" />
    </Helmet>
  )
}

export default SEO
